<template>
  <div 
    id="admin-page" 
    v-loading.fullscreen.lock="isLoading"
    element-loading-text="拼命加载中">
    <Login 
      v-if="!user.isLogin"
      @login="fetchLogin"/>
    <div v-else>
      <el-container>
        <!-- 头部 -->
        <el-header>
          <AdminHeader/>
        </el-header>
        <el-container class="main-container">
          <el-aside width="160px">
            <AdminAside/>
          </el-aside>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import User from '@/model/User';
import Login from '@/components/Login.vue';
import AdminHeader from '@/components/AdminHeader.vue';
import AdminAside from '@/components/AdminAside.vue'

export default {
  name: 'Admin',
  components: {
    Login,
    AdminHeader,
    AdminAside
  },
  data() {
    return {
      user: new User(this),
      isLoading: true,
    }
  },
  async created() {
    document.title = '全国天气面板-管理后台'
    await this.user.getIsLogin();
    this.isLoading = false;
  },
  methods: {
    async fetchLogin(userForm) {
      await this.user.getLogin(userForm);
    }
  }
}
</script>

<style lang="less">
  #admin-page {
    color: #444;
    min-height: 100vh;
    .el-header {
      border-bottom: 1px solid #eee;
      height: 50px!important;
    }
    .main-container {
      height: calc(100vh - 50px);
    }
    .el-aside, .el-menu {
      height: 100%;
    }
  }
</style>